// ----------------------------------------------------------------------

type InputValue = string | number | null;

export function fNumber(number: InputValue): string {
  return number !== null && number !== undefined ? new Intl.NumberFormat().format(Number(number)) : '';
}

export function fCurrency(number: InputValue): string {
  const formattedNumber = number !== null && number !== undefined ? new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(number)) : '0.00';
  return `${result(formattedNumber, '.00')} MAD`;
}

export function fPercent(number: InputValue): string {
  const format = number !== null && number !== undefined ? (Number(number) / 100).toLocaleString('en-US', { style: 'percent', minimumFractionDigits: 1 }) : '0.0%';
  return result(format, '.0');
}

export function fShortenNumber(number: InputValue): string {
  if (number === null || number === undefined) return '0.00';
  
  const absNumber = Math.abs(Number(number));
  const units = ['K', 'M', 'B', 'T'];
  let unit = '';

  for (let i = units.length - 1; i >= 0; i -= 1) {
    const size = 10 ** ((i + 1) * 3);
    if (absNumber >= size) {
      unit = units[i];
      number = Number(number) / size;
      break;
    }
  }
  
  const formattedNumber = Number(number).toFixed(2);
  return result(`${formattedNumber}${unit}`, '.00');
}

export function fData(number: InputValue): string {
  if (number === null || number === undefined) return '';

  const formattedNumber = (Number(number) / 1024).toLocaleString('en-US', { minimumFractionDigits: 1, maximumFractionDigits: 1 });
  return `${formattedNumber} GB`;
}

function result(format: string, key = '.00'): string {
  const isInteger = format.includes(key);
  return isInteger ? format.replace(key, '') : format;
}
